<div class="page-norights">
  <h1 class="landing">{{ 'norights.title' | transloco }}</h1>

  <p class="fw-bolder">{{ 'dearUser' | transloco }}</p>
  <div class="text">
    <p class="mb-0 translate">{{ 'blocked.description' | transloco }}</p>
  </div>

  <app-contacts-info></app-contacts-info>

  <button class="primary xl w-100 mt-3 logout-btn" disableRipple [routerLink]="['/logout']" data-test="norights_btn-logout">
    {{ 'norights.button_auto' | transloco }}
  </button>
</div>
